/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { FormGrid } from '../../../../../styles/layout/FormGrid';
import { Field } from '../../../../../styles/forms/Field';
import { MANUAL_STEP_FIELDS } from '../manualSteps';

// ---------------------------------------------------------------------------
// Campos de UM passo manual, dirigidos pela config (manualSteps.js). Reusado
// pelo painel da etapa ativa (StepWorkPanel) e pelo modal de edição retroativa
// (ManualStepModal) — mesma renderização nos dois contextos.
// ---------------------------------------------------------------------------

export default function ManualStepFields({
   stepKey,
   draft,
   onChange,
   disabled = false,
   idPrefix = 'manual-step',
   children = null,
}) {
   const fields = MANUAL_STEP_FIELDS[stepKey] ?? [];

   const handleChange = (event) => {
      const { name, value, type, checked } = event.target;
      onChange(name, type === 'checkbox' ? checked : value);
   };

   // Largura padrão por tipo; a config pode sobrescrever com `col` (ex.: as
   // sub-análises do background check em 2 colunas).
   const colOf = (field, fallback) => `col-${field.col ?? fallback}`;

   return (
      <FormGrid>
         {fields.map((field) => {
            const id = `${idPrefix}-${field.key}`;

            if (field.type === 'checkbox') {
               return (
                  <Field className={colOf(field, 6)} key={field.key}>
                     <label
                        htmlFor={id}
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '8px',
                           cursor: disabled ? 'default' : 'pointer',
                        }}
                     >
                        <input
                           id={id}
                           type="checkbox"
                           name={field.key}
                           checked={Boolean(draft[field.key])}
                           onChange={handleChange}
                           disabled={disabled}
                        />
                        {field.label}
                     </label>
                  </Field>
               );
            }

            if (field.type === 'select') {
               return (
                  <Field className={colOf(field, 6)} key={field.key}>
                     <label htmlFor={id}>{field.label}</label>
                     <select
                        id={id}
                        name={field.key}
                        value={draft[field.key] ?? ''}
                        onChange={handleChange}
                        disabled={disabled}
                     >
                        {(field.options ?? []).map((option) => (
                           <option key={option.value} value={option.value}>
                              {option.label}
                           </option>
                        ))}
                     </select>
                  </Field>
               );
            }

            if (field.type === 'textarea') {
               return (
                  <Field className={colOf(field, 12)} key={field.key}>
                     <label htmlFor={id}>{field.label}</label>
                     <textarea
                        id={id}
                        name={field.key}
                        rows={3}
                        value={draft[field.key] ?? ''}
                        onChange={handleChange}
                        disabled={disabled}
                        placeholder={field.placeholder}
                     />
                  </Field>
               );
            }

            // date (e fallback de texto)
            return (
               <Field className={colOf(field, 6)} key={field.key}>
                  <label htmlFor={id}>{field.label}</label>
                  <input
                     id={id}
                     type={field.type}
                     name={field.key}
                     value={draft[field.key] ?? ''}
                     onChange={handleChange}
                     disabled={disabled}
                  />
               </Field>
            );
         })}

         {/* Controles extras do passo, dentro do mesmo grid (ex.: laudo do
             exame — coluna ao lado do seletor de resultado). */}
         {children}
      </FormGrid>
   );
}

ManualStepFields.propTypes = {
   stepKey: PropTypes.string.isRequired,
   draft: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
   ).isRequired,
   onChange: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
   idPrefix: PropTypes.string,
   children: PropTypes.node,
};
